export function getPostLogoutUrl() {
  return import.meta.env.VITE_POST_LOGOUT_URL?.trim() || '';
}
